import { render, staticRenderFns } from "./virtualGoods.vue?vue&type=template&id=3183177c&scoped=true&"
import script from "./virtualGoods.vue?vue&type=script&lang=ts&"
export * from "./virtualGoods.vue?vue&type=script&lang=ts&"
import style0 from "./virtualGoods.vue?vue&type=style&index=0&id=3183177c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3183177c",
  null
  
)

export default component.exports